import React, { useEffect, useRef, useState } from 'react';
import { Popup, Button, Input } from 'semantic-ui-react';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { SHARE_DATA_VIEW } from '../../../../../constants';

type Input = typeof Input;

type Props = {
  actions: any;
  location: any;
  selectedView: any;
  entityType: string;
  filterState: any;
  shareUrl: string;
  sharedDataViewName: string | null;
};

function ShareDataViewPopup({
  actions,
  location,
  selectedView,
  entityType,
  filterState,
  shareUrl,
  sharedDataViewName,
}: Props) {
  const [shareUrlValue, setShareUrlValue] = useState(window.location.href);
  const shareUrlRef = useRef<Input>(null);
  const [showQR, setShowQR] = useState(false);
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const sharedDataView = urlParams.get('sharedDataView');

  useEffect(() => {
    if (
      sharedDataView &&
      sharedDataView.length > 0 &&
      window.location.href.includes(SHARE_DATA_VIEW)
    ) {
      actions.shareDataView(sharedDataViewName, sharedDataView, entityType);
    }
    //If the length of the dataview name is to large, then it is displayed in title attribute
    const options = document.querySelectorAll('.viewSelectInlineBlock > .menu div .text');
    options.forEach((option: any) => {
      if (option.textContent.length > 30) {
        option.title = option.textContent;
      }
    });
  }, []);

  useEffect(() => {
    createShareDataViewLink();
    copyToClipboard();
  }, [shareUrl]);

  const createShareDataViewLink = () => {
    let { href } = window.location;

    if (shareUrl && shareUrl.length > 0) {
      if (href.indexOf(SHARE_DATA_VIEW) > 0) {
        href = href.substr(0, href.indexOf(SHARE_DATA_VIEW));
      }

      const url = `${href}${SHARE_DATA_VIEW}${shareUrl}`;
      window.history.replaceState('', '', url);
    } else {
      window.history.replaceState('', '', href.substr(0, href.indexOf(SHARE_DATA_VIEW)));
    }
  };

  const copyToClipboard = () => {
    if (shareUrlRef && shareUrlRef.current && shareUrl.length > 0) {
      setShareUrlValue(window.location.href);
      //copy to clipboard
      const dummy = document.createElement('input');
      document.body.appendChild(dummy);
      dummy.setAttribute('id', 'dummy_id');
      (document.getElementById('dummy_id') as HTMLInputElement).value = window.location.href;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      shareUrlRef.current.select();
      toast.success(t('message.title.success.copied.to.clipboard'));
    }
    if (shareUrl.length > 0) {
      setShowQR(true);
    }
  };

  const onShareDataViewButton = () => {
    actions.getShareUrlDataView(
      sharedDataViewName || selectedView.text,
      selectedView.value,
      entityType,
      filterState,
      filterState.filterValues
    );
  };

  const onCopyButton = (e: any) => {
    shareUrlRef.current!.select();
    document.execCommand('copy');
    e.target.focus();
  };

  return (
    <Popup
      key="shareDataViewToolTip"
      trigger={
        <Button
          icon="share alternate"
          type="button"
          onClick={() => {
            onShareDataViewButton();
          }}
          className="mini"
        />
      }
      size="mini"
      on="click"
      position="top right"
    >
      <Input
        value={shareUrlValue}
        ref={shareUrlRef}
        style={{ fontSize: '1.3em', marginRight: '5px' }}
      />
      {document.queryCommandSupported('copy') && (
        <ButtonWrapper
          icon="copy"
          type="button"
          onClick={(e: any) => {
            onCopyButton(e);
          }}
        />
      )}
    </Popup>
  );
}

export default ShareDataViewPopup;
